export default "__VITE_ASSET__D0d4ZMab__"